import { useEffect } from 'react';

/**
 * useDidMount hook
 * @description Calls a function on mount
 *
 * @param {Function} callback Callback function to be called on mount
 * @see https://rooks.vercel.app/docs/useDidMount
 */
function useDidMount(callback) {
    useEffect(() => {
        if (typeof callback === "function") {
            callback();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

export { useDidMount };
